import { ButtonV2 } from '@cimplico/components';
import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { Worksheet, WorksheetStatusEnum } from '../../types/worksheet';
import StatusBadge from '../worksheet-v2/top-section/StatusBadge';
import ReviewButton from '../worksheet-v2/top-section/top-actions/ReviewButton';
import SecondaryActions from '../worksheet-v2/top-section/top-actions/SecondaryActions';

type StatusPreviewProps = {
    worksheet: Worksheet;
};

function StatusPreview({ worksheet }: StatusPreviewProps): JSX.Element {
    return (
        <div className="flex items-center gap-1">
            <StatusBadge status={worksheet.status} />
            <div className="ml-auto"></div>
            <ReviewButton worksheet={worksheet} compactView />
            <SecondaryActions worksheet={worksheet} compactView />
        </div>
    );
}

export default StatusPreview;
